import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';

// Mirrors @wsphere/warranties/web's rating-matrix shapes — can't import them directly since
// warranties/web already depends on distributors/web (the provisioning picker), so it'd be circular.

export interface Dimension {
  id: string;
  title: string;
  isScalar?: boolean;
  isPricing: boolean;
  isSystem: boolean;
}

export interface Element {
  id: string;
  title: string;
  dimensionId: string;
  parentId: string | null;
  policyId?: string | null;
  description?: string | null;
  sortOrder?: number | null;
  parent?: Element | null;
  dimension?: Dimension;
  unsummedOffset?: boolean;
}

export interface CellElement {
  elementId: string;
  element?: Element;
}

export interface Cell {
  id: string;
  planId: string;
  value: number;
  /** Set for a formula cell, whose `value` is always 0. */
  formula?: { percent: number; feeTypeTitles: string[] } | null;
  effectiveFrom: string | null;
  effectiveTo: string | null;
  elements: CellElement[];
}

export interface DistributorCommissionPlan {
  id: string;
  title: string;
}

export interface DistributorCommissionPolicy {
  id: string;
  title: string;
  policyNumber: string;
  plans: DistributorCommissionPlan[];
}

@Injectable()
export class CommissionService {
  constructor(private http: HttpClient) {}

  async listPolicies(distributorId: string) {
    return firstValueFrom(
      this.http.get<{ items: DistributorCommissionPolicy[] }>(`/api/distributors/${distributorId}/commission/policies`)
    );
  }

  async listCells(distributorId: string, planId: string) {
    return firstValueFrom(
      this.http.get<{ items: Cell[] }>(`/api/distributors/${distributorId}/commission/plans/${planId}/cells`)
    );
  }
}
